export default class flashCards {
    constructor(selector) {
        this.CARD_SWITCH_RANGE = '100%'; // distance the card must move before it fades into the background
        this.CARD_ARRAY = [...document.querySelectorAll(selector)];

        this.COUNT_OF_CARDS = this.CARD_ARRAY.length;
        this.last_element = this.CARD_ARRAY[this.CARD_ARRAY.length - 1];
        this.isMoving = false;
        this.CARD_PEN_OFFSET = 0;
        this.CARD_PEN_OFFSET_UNITS = 'px';
        this.offsetArray = [];

    }

    setVariables () {
        this.CARD_PEN_OFFSET = $(window).width() > 576 ? 10.4 : 90; //displacement of the cards
        this.CARD_PEN_OFFSET_UNITS =  $(window).width() > 576 ? 'vw' : 'px';
        let offset = 0;
        for (let i = 1; i <= this.COUNT_OF_CARDS; i++) {
            this.offsetArray.push(offset + this.CARD_PEN_OFFSET_UNITS);
            offset += this.CARD_PEN_OFFSET;
        }
    }

    setCardOffset() {
        this.setVariables();
        this.CARD_ARRAY.forEach( (item, index) => {
            item.style.zIndex = Math.abs(index - this.COUNT_OF_CARDS);
            item.style.transform = index > 0 ?
                `translate(-${this.offsetArray[index]},0px) scale3d(0.912, 0.912, 0.912)` :
                `translate(-${this.offsetArray[index]},0px)`;
        });
    }

    offsetSwitch() {
        for (let index of this.CARD_ARRAY) {
            let zIndex =  parseInt(index.style.zIndex) + 1;
            index.style.zIndex = zIndex ;
            let offsetIndex = Math.abs(parseInt(index.style.zIndex) - this.COUNT_OF_CARDS);
            index.style.transform = index.classList.contains('image-slide-active') ?
                `translate(-${this.offsetArray[offsetIndex]},0px) scale3d(0.912, 0.912, 0.912)` :
                `translate(-${this.offsetArray[offsetIndex]},0px)`;
            index.addEventListener('transitionend', () => this.isMoving = false, {once: true });

            if(zIndex > 1) {
                index.classList.add('image-slide-active');
            } else {
                index.classList.remove('image-slide-active');
            }
        }
    }


     cardSwitching() {
        let animationObject = {};

        if (this.isMoving) return;

        for (let index of this.CARD_ARRAY) {
            if ((parseInt(window.getComputedStyle(index).zIndex) === this.CARD_ARRAY.length) || (parseInt(index.style.zIndex) === this.CARD_ARRAY.length)) {

                animationObject =  index;
                animationObject.style.transform = `translate(${this.CARD_SWITCH_RANGE},0px) scale3d(0.912, 0.912, 0.912)`;
                this.isMoving = true;
            }
        }

            animationObject.addEventListener('transitionend', () => {
                    animationObject.style.zIndex = 0;
                    animationObject.style.transform = `translate( - ${this.offsetArray[this.COUNT_OF_CARDS]},0px)`;
                    this.offsetSwitch();
            }, {once: true });
    }


    init() {
        this.setCardOffset();
        $(window).on('resize',  () => {
            this.offsetArray = [];
            this.setCardOffset();
        })
    }
}



